export const PRODUCT_CODE = 'pdp.product_code';
